import * as Yup from 'yup';
export const phoneRegExp = /^\+\d{1,3}\(\d{3}\)\d{3}-\d{4}$/;
export const nameRegex = /^[A-Za-z -]{0,30}$/;
export const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
export const contactRegex = /^(\+\d{1,3})?\s?\(?\d{3}\)?-?\s?\d{3}-?\d{4}$/;
export const npiRegex = /^[1-9][0-9]*$/;
export const zipCode = /^(?:\d{5}(?:-\d{4})?|\d{9})$/;
export const websiteRegex =
    /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?(\/[^\s]*)?$/;
export const CityRegex =
    /^([a-zA-Z\u0080-\u024F]+(?:. |-| |'))[a-zA-Z\u0080-\u024F]$/;
export const faxIdRegex = /^(\+\d{1,3})?\s?\(?\d{3}\)?-?\s?\d{3}-?\d{4}$/;
export const withoutSpaceRegex = /^[^\s]+$/;
export const descriptionRegex =
    /^[^-\s][a-zA-Z0-9~`!@#\$%\^&\*\(\)_\-\+={\[\}\]\|\\:;"'<,>\.\?\n/  ]$/;
export const sudomainRegex = /^[A-Za-z]*$/;
export const firstLastNameRegex = /^[a-zA-Z\s]+$/;
export const name = /^[A-Za-z]+( [A-Za-z]+)*$/;
export const allowedCharactersRegexWithRegex = /^[a-zA-Z0-9\-.,' ]+$/;
export const username = /^[a-zA-Z0-9]+$/;
export const nameWithoutSpace = /^[a-zA-Z]+$/;
export const ssn = /^\d{9}$/

const customValidation = (
    title: string,
    isRequired: boolean,
    isRegex: boolean,
    isExcludeEmptySting: boolean,
    regex: any,
    min: number,
    max: number
) => {
    if (isRequired && isRegex)
        return Yup.string()
            .required(`Please enter a valid ${title}`)
            .test('no-empty-spaces', `Please enter a valid ${title}`, (value) => {
                if (typeof value === 'string' && value.trim() === '') {
                    return false;
                }
                return true;
            })
            .transform((value, originalValue) => {
                if (typeof originalValue === 'string') {
                    return originalValue.trim();
                }
                return originalValue;
            })
            .matches(regex, {
                message: `Please enter a valid ${title}`,
                excludeEmptyString: isExcludeEmptySting,
            })
            .min(min, `${title} should be at least ${min} characters`)
            .max(max, `${title} should be at most ${max} characters`);
    else if (isRequired)
        return Yup.string()
            .required(`Please enter a valid ${title}`)
            .test('no-empty-spaces', `Please enter a valid ${title}`, (value) => {
                if (typeof value === 'string' && value.trim() === '') {
                    return false;
                }
                return true;
            })
            .transform((value, originalValue) => {
                if (typeof originalValue === 'string') {
                    return originalValue.trim();
                }
                return originalValue;
            })
            .min(min, `${title} should be at least ${min} characters`)
            .max(max, `${title} should be at most ${max} characters`);
    else if (regex)
        return Yup.string()
            .matches(regex, {
                message: `Please enter a valid ${title}`,
                excludeEmptyString: isExcludeEmptySting,
            })
            .test(
                'minimumCharacter',
                `${title} should be at least ${min} characters`,
                (value) => {
                    if (!value || value?.length === 0) return true;
                    if (value?.length >= 0 && value.length < min) return false;
                    if (value?.length >= min) return true;
                }
            )
            .test(
                'maximumCharacter',
                `${title} should be at most ${max} characters`,
                (value) => {
                    if (!value || value?.length === 0) return true;
                    if (value?.length >= 0 && value.length > max) return false;
                    if (value?.length <= max) return true;
                }
            );
    else
        return Yup.string()
            .notRequired()
            .test(
                'minimumCharacter',
                `${title} should be at least ${min} characters`,
                (value) => {
                    if (!value || value?.length === 0) return true;
                    if (value?.length >= 0 && value.length < min) return false;
                    if (value?.length >= min) return true;
                }
            )
            .test(
                'maximumCharacter',
                `${title} should be at most ${max} characters`,
                (value) => {
                    if (!value || value?.length === 0) return true;
                    if (value?.length >= 0 && value.length > max) return false;
                    if (value?.length <= max) return true;
                }
            );
};

export const commonValidation = {
    customValidation,

    emailMadatory: Yup.string()
        .transform((value) => value.toLowerCase())
        .matches(emailRegex, {
            message: 'Please Enter a valid Email',
        })
        .required('Please enter a valid Email')
        .max(255, 'Email should be at most 255 characters'),

    physicalAddress: Yup.object().shape({
        addressLine1: Yup.string()
            .required('Please enter a valid AddressLine1')
            .min(3, 'Address line1 should be at least 3 character')
            .max(255, 'Address Line1 should be at most 255 character'),
        addressLine2: Yup.string()
            .required('Please enter a valid AddressLine2')
            .min(3, 'Address line2 should be at least 3 character')
            .max(255, 'Address Line2 should be at most 255 character'),
        street: Yup.string()
            .required('Please enter a valid Street')
            .min(3, 'Street should be at least 3 character')
            .max(255, 'Street Line2 should be at most 255 character'),
        city: Yup.string().required('Please enter a valid City'),
        state: Yup.string().required('Please enter a valid State'),
        country: Yup.string().required('Please enter a valid Country'),
        zipCode: Yup.string()
            .required('Please enter a valid Zipcode')
            .matches(zipCode, 'Please enter a valid Zipcode'),
    }),
    billingAddress: Yup.object().shape({
        addressLine1: Yup.string()
            .test(
                'minimumCharacter',
                `Address Line 1 should be at least 3 characters`,
                (value) => {
                    if (!value || value?.length === 0) return true;
                    if (value?.length >= 0 && value.length < 3) return false;
                    if (value?.length >= 3) return true;
                }
            )
            .test(
                'maximumCharacter',
                `Address Line 1  should be at most 255 characters`,
                (value) => {
                    if (!value || value?.length === 0) return true;
                    if (value?.length >= 0 && value.length > 255) return false;
                    if (value?.length <= 255) return true;
                }
            ),
        addressLine2: Yup.string()
            .test(
                'minimumCharacter',
                `Address Line 2 should be at least 3 characters`,
                (value) => {
                    if (!value || value?.length === 0) return true;
                    if (value?.length >= 0 && value.length < 3) return false;
                    if (value?.length >= 3) return true;
                }
            )
            .test(
                'maximumCharacter',
                `Address Line 2  should be at most 255 characters`,
                (value) => {
                    if (!value || value?.length === 0) return true;
                    if (value?.length >= 0 && value.length > 255) return false;
                    if (value?.length <= 255) return true;
                }
            ),
        street: Yup.string()
            .test(
                'minimumCharacter',
                `Street 2 should be at least 3 characters`,
                (value) => {
                    if (!value || value?.length === 0) return true;
                    if (value?.length >= 0 && value.length < 3) return false;
                    if (value?.length >= 3) return true;
                }
            )
            .test(
                'maximumCharacter',
                `Street 2  should be at most 255 characters`,
                (value) => {
                    if (!value || value?.length === 0) return true;
                    if (value?.length >= 0 && value.length > 255) return false;
                    if (value?.length <= 255) return true;
                }
            ),
        city: Yup.string(),
        state: Yup.string(),
        country: Yup.string(),
        zipCode: Yup.string().matches(zipCode, {
            excludeEmptyString: true,
            message: 'Please enter a valid Zipcode',
        }),
    }),
    email: Yup.string()
        .transform((value) => value.toLowerCase())
        .matches(emailRegex, {
            excludeEmptyString: true,
            message: 'Please Enter a valid Email',
        })
        .test(
            'maximumCharacter',
            `Email should be at most 255 characters`,
            (value) => {
                if (!value || value?.length === 0) return true;
                if (value?.length >= 0 && value.length > 255) return false;
                if (value?.length < 256) return true;
            }
        ),
    contactNumber: Yup.string().matches(contactRegex, {
        excludeEmptyString: true,
        message: 'Please Enter a valid Contact Number',
    }),
    faxNumber: Yup.string().matches(faxIdRegex, {
        excludeEmptyString: true,
        message: 'Please enter a valid Fax Id',
    }),
    description: Yup.string().test(
        'maximumCharacter',
        `Description should be at most 1024 characters`,
        (value) => {
            if (!value || value?.length === 0) return true;
            if (value?.length >= 0 && value.length > 1024) return false;
            if (value?.length < 1025) return true;
        }
    ),
    acceptablePayerPlan: Yup.object().shape({
        facilityPlan: Yup.string().required(),
        residencePlan: Yup.string().required(),
        accountPlan: Yup.string().required(),
    }),
    status: Yup.string().required().default('Active'),
    active: Yup.boolean().required(),
    payerType: Yup.object().required(),
    startDate: Yup.date().required('Start date is required'),
    terminationDate: Yup.date().required('Termination date is required')
        .min(Yup.ref('startDate'), 'Termination Date must be greater than or equal to Start Date'),
    supportedPlatform: Yup.string().default('Select the platform'),
    userIdentification: Yup.string(),
    facility: Yup.array().of(Yup.string()),
    employementType: Yup.object().required('Please enter valid Employment Type'),
};
